export default __webpack_public_path__ + "static/media/14M.28e48f63.jpeg";